import api from "./api";

export async function deleteWorkspace(id: string) {
  const res = await api.delete<unknown>(`/workspace/${id}`);
  return res.data;
}
